export default __webpack_public_path__ + "static/media/4.9a56e1ed.png";